import React from 'react';
import { connect } from 'react-redux';
import Row from './row';

const PeopleTableBody = ({ data, type, selectable = true }) => (
  <div className="Content-tableBody Table-body">
    {data.map((content, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <Row key={i} index={i} type={type} selectable={selectable} {...content} />
    ))}
  </div>
);

const mapStateToProps = state => ({
  data: state.data.content,
  type: state.data.contentType,
});

export default connect(mapStateToProps)(PeopleTableBody);
